import React from 'react';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';
import { NoteTemplate } from '../../../../api/note-templates';
import { NOTE_TEMPLATE_CATEGORIES } from '../../../../utils/constants';
import './NoteTemplatesTable.scss';

type Props = {
    templateData: NoteTemplate;
    onView: (template: NoteTemplate) => void;
};

const NoteTemplatesTableRow: React.FC<Props> = ({ templateData, onView }) => {
    const categoryLabel = NOTE_TEMPLATE_CATEGORIES.find(
        (cat) => cat.key === templateData.category
    )?.value || templateData.category;

    const onOptionClick = (id: number, action: string) => {
        if (action === 'view') {
            onView(templateData);
        }
    };

    return (
        <div className='table-row'>
            <div className='table-cell'>
                {templateData.name || '-'}
            </div>
            <div className='table-cell'>
                {categoryLabel || '-'}
            </div>
            {/* <div className='table-cell template-content'>
                {templateData.template ? (
                    <div dangerouslySetInnerHTML={{ __html: templateData.template }} />
                ) : '-'}
            </div> */}
            <div className='table-cell actions'>
                <TableRowActionMenu
                    options={[
                        { key: 'view', value: 'View / Edit' }
                    ]}
                    id={templateData.id}
                    onActionMenuClick={onOptionClick}
                />
            </div>
        </div>
    );
};

export default NoteTemplatesTableRow;
